import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import LoginForm from './../block/LoginForm'
import Breadcrumbs from './../block/Breadcrumbs'
import LkSidebar from './../block/LkSidebar'

import ProductCardSm from './../block/ProductCardSm';

import { Container, Pagination as BPagination } from 'react-bootstrap'

import styles from './../style/Lk.module.scss'

export default class Favorite extends Component {

  static defaultProps = {
    cart: []
  }

  constructor(props) {
    super(props)

    this.state = {
      products: null,
      count: 0,
      page: 1,
      cartCount: props.cart.reduce((total, item) => total + item.count, 0)
    }
  }

  logOut() {
    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'logout'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        location.reload()
      }
    })
  }

  loadProducts = () => {
    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this

    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'load_favorite_products',
      'items': this.props.favorite,
      'page': this.state.page
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        products: response.data.products,
        count: response.data.count,
        page: response.data.page
      })
    })
  }

  inCart = ( id ) => {
    const { cart } = this.props
    var fined = false
    cart.map(( celm ) => {
      if( celm.resource == id ) {
        fined = true
      }
    })
    return fined
  }

  changePage = ( num ) => {
    const { page } = this.state

    if(num == page) return
    this.setState({
      page: num
    }, () => {
      this.loadProducts()
    })
  }

  componentDidMount() {
    this.loadProducts()
  }

  render() {

    const { ajax_data, data, favorite, changeFavorite, cart, addTocart, user_profile_type, loading_user, authorized } = this.props,
    { products, page, count, cartCount } = this.state

    if (loading_user) {
      return (
        <>
          <div className='w-100 d-flex align-items-center' style={{ flex: 1 }}>
            <div className="container text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <p className="mt-3">Загрузка данных...</p>
            </div>
          </div>
        </>
      )
    }

    return (
      <div className='w-100' style={{ flex: 1 }}>
        {ajax_data != null &&
          <>
            {authorized ?
              <>
                <Breadcrumbs items={ajax_data.breadcrumbs} />
                <div className={styles.lk_page}>
                  <Container className={styles.container}>
                    <h1>{ajax_data.pagetitle}</h1>
                    <div className={styles.lk_page_block}>

                      <LkSidebar 
                        data={data} 
                        cartCount={cartCount} 
                        logOut={() => this.logOut()} 
                        active={4}
                        user_profile_type={user_profile_type}
                      />

                      <div className={styles.lk_page_block_right}>
                        {products != null ?
                          <>
                            {products.length > 0 ?
                              <>
                                <div className={styles.recomendedng_catalog_fav}>
                                  {products.map(( product, i ) => {
                                    return (
                                      <ProductCardSm
                                        id={product.id}
                                        title={product.title}
                                        image={product.image}
                                        article={product.article}
                                        manufacturer={product.manufacturer}
                                        price={product.price}
                                        old_price={product?.old_price}
                                        inStock={product.inStock}
                                        recomended={product.recomended}
                                        changeFavorite={changeFavorite}
                                        favorite={favorite}
                                        cart={cart}
                                        addTocart={addTocart}
                                        user_profile_type={user_profile_type}
                                        link={product.url}
                                        fullWidth={true}
                                        certificate={product?.certificate}
                                      />
                                    )
                                  })}
                                </div>
                                <div className='d-flex justify-content-center'>
                                  <BPagination className={styles.recomendedng_pagenav}>
                                    {[...Array( count )].map(( num, key ) => {
                                      num = key + 1
                                      return (
                                        <BPagination.Item onClick={() => this.changePage( num )} key={key} active={num == page ? true : false}>{num}</BPagination.Item>
                                      )
                                    })}
                                    {page < count &&
                                      <BPagination.Next onClick={() => this.changePage( page + 1 )}>След →</BPagination.Next>
                                    }
                                  </BPagination>
                                </div>
                              </>
                            :
                              <div style={{ textAlign: `center`, margin: `30px 0px` }}>Перейдите в <a href="/katalog/">каталог</a> и добавьте товары в избранное</div>
                            }
                          </>
                        :
                          <div style={{ textAlign: `center`, margin: `30px 0px` }}>Перейдите в <a href="/katalog/">каталог</a> и добавьте товары в избранное</div>
                        }
                      </div>
                    </div>
                  </Container>
                </div>
              </>
            :
              <>
                <Breadcrumbs items={ajax_data.breadcrumbs} />
                <LoginForm
                  ajax_data={ajax_data}
                  user_profile_type={user_profile_type}
                />
              </>
            }
          </>
        }
      </div>
    )
  }
}

Favorite.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string,
  authorized: PropTypes.bool,
  loading_user: PropTypes.bool
}